import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import Header from "../../layout/header";
import { Box, Button, Stack, Typography } from "@mui/material";
import ReportContent from "../../components/dashboard/report-content";
import { BackArrowIcon } from "../../components/ui-elements/svg-icons";

import { useLocation, useNavigate } from "react-router-dom";
import {
  PostContentDetails,
  PostContentDetailsDummy,
} from "../../interface/posts";
import { useQuery } from "@tanstack/react-query";
import { apiGetPostDetails } from "../../api/post";
import { useNotificationService } from "../../hooks/notification";
import { getComments } from "../../utils/comment-request";
import { CommentData } from "../../interface/comment";
import { SkeletonLoading } from "../../components/ui-elements/skeleton-loading";
import useResponsive from "../../hooks/useResponsive";
import PetitionContent from "../../components/dashboard/petition-report";

const Report: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isSmall = useResponsive("down", "sm", "xl");
  const location = useLocation();
  const { postId } = location.state || {};
  const { showNotification } = useNotificationService();
  const [post_details, setPost_details] = useState<PostContentDetails>(
    PostContentDetailsDummy
  );

  const [comment_data, setComment_data] = useState<CommentData[]>([]);

  const { data, refetch, isLoading } = useQuery({
    queryKey: ["postDetails", postId],
    queryFn: async () => {
      if (!postId) return PostContentDetailsDummy;
      const result = await apiGetPostDetails(Number(postId ?? 0));
      if (result.status === "error" && "details" in result) {
        showNotification(result.details, "error");
        return {};
      }
      if (result?.status === 200) {
        setPost_details(result.data);
        await fetchComment();
      }
      return result?.data || PostContentDetailsDummy;
    },
    enabled: !!postId, // Only run the query if postId exists
  });

  // Use an effect to refetch when postId changes
  useEffect(() => {
    if (postId) {
      refetch();
    }
  }, [postId, refetch]);

  const fetchComment = async () => {
    const request = await getComments(postId);
    if (Array.isArray(request?.data)) {
      setComment_data(request?.data);
    } else setComment_data([]);
  };

  const refetch_comment = async () => {
    await fetchComment();
  };

  return (
    <>
      {/* Header Menu */}
      <Box
        sx={{
          background: theme.palette.background.paper,
        }}
      >
        <Header scrollContainerId={"main-report-scroll-container"}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Button onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </Button>
            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
              Your Community Report
            </Typography>
          </Stack>
        </Header>
        {isLoading && (
          <Box
            sx={{
              width: isSmall ? "90%" : 600,
              height: "90vh",
              pt: "6rem",
              mx: "auto",
            }}
          >
            <SkeletonLoading />
          </Box>
        )}
        {!isLoading &&
          !!data &&
          (post_details?.post_type === "petition" ? (
            <PetitionContent
              post_details={post_details}
              comment_data={comment_data}
              refetch_comment={refetch_comment}
            />
          ) : (
            <ReportContent
              post_details={post_details}
              comment_data={comment_data}
              refetch_comment={refetch_comment}
            />
          ))}
      </Box>
    </>
  );
};

export default Report;
